import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/icon/view-more.png'


const _hoisted_1 = { src: _imports_0 }

import { ref, onMounted } from 'vue'
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'DropDown',
  setup(__props) {

const loadUrl: any = ref({})

onMounted(async() => {
  //
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", _hoisted_1))
}
}

})